<template>
  <b-modal id="productSearch" ref="productSearch" no-close-on-esc @hidden="resetModal" @close="resetModal">
    <template slot="modal-title">{{$t('productSearch')}}
    </template>

    <b-form-group id="productSearch">
      <b-form-input size="sm" v-model.trim="request.searchText" :placeholder="$t('typeProductAndHitEnter')" type="text" v-on:keyup="onKeyup" autofocus/>
      <p/>
      <strong v-if="resultCountProducts === 0 " class="text-info"> {{ $t('noResults')}}</strong>
      <div class="aco-dropdown-item" v-for="product in products" :key="product.sourceId" @click="selectProduct(product)">
        {{ product.name }} ({{ product.ean }})
      </div>
    </b-form-group>

    <b-form-group id="filter-group" :label="$t('filter')">
      <b-form-checkbox size="sm" v-model="request.active" name="checkbox" switch inline>{{ $t('onlyActive') }}</b-form-checkbox>
    </b-form-group>

    <b-form-group v-if="productName" id="productName-group" :label="$t('name')" label-for="name">
      <b-form-input size="sm" id="productName" type="text" v-model="productName" readonly/>
    </b-form-group>

    <b-form-group v-if="productType" id="productType-group" :label="$t('productType')" label-for="productType">
      <b-form-select size="sm" id="role" v-model="productType" :options=this.productTypes :disabled="true">
      </b-form-select>
    </b-form-group>

    <b-form-group v-if="ean" id="ean-group" :label="$t('ean')" label-for="ean">
      <b-form-input size="sm" id="ean" type="text" v-model="ean" readonly/>
    </b-form-group>

    <div slot="modal-footer" class="col-md-12">
      <b-button variant="primary" class="float-lg-right" v-on:click="updateProduct" :disabled=validate>{{ $t('use') }}</b-button>
      <b-button variant="secondary" class="float-lg-left" v-on:click="resetModal" >{{ $t('cancel') }}</b-button>
    </div>

  </b-modal>
</template>

<script>
  import ProductService from '../services/ProductService'
  import BaseComponent from './BaseComponent'

  export default {
    name: 'ProductSearch',
    props: {
      data: {
        type: Object
      }
    },
    extends: BaseComponent,
    data() {
      return {
        request: {
          searchText: '',
          active: true
        },
        productName: '',
        products: [],
        productType: '',
        ean: '',
        isButtonDisabled: true,
        product: {}
      }
    },
    computed: {
      validate () {
        return (this.productName === null && this.isButtonDisabled === true)
      },
      resultCountProducts () {
        return this.products && this.products.length
      }
    },
    methods: {
      onKeyup (event) {
        if (event.which === 13) {
          this.productSearch()
        }
      },
      productSearch () {
        ProductService.searchProduct(this.request, this.data)
          .then((response) => {
            this.products = response.response
          })
      },
      showModal () {
        this.resetModal()
        this.$bvModal.show('productSearch')
      },
      resetModal () {
        this.productName = null
        this.products = null
        this.request.searchText = null
        this.request.active = true
        this.productType = null
        this.ean = null
        this.isButtonDisabled = true
        this.$refs['productSearch'].hide()
      },
      selectProduct (product) {
        this.productName = product.name
        this.productType = product.productType
        this.ean = product.ean
        this.product = product
        this.products = ''
        this.isButtonDisabled = false
      },
      updateProduct () {
        this.$emit('selectedEan', this.product)
        this.resetModal()
      }
    },
    watch: {
      'request.active': function () {
        if(this.request.searchText)  {
          this.productSearch()
        }
      }
    },
    i18n: {
      messages: {
        en: {
          'onlyActive': 'Only active products'
        },
        nb: {
          'onlyActive': 'Kun aktive produkter'
        }
      }
    }
  }
</script>
